/*
 * @Description:请求配置文件
 * @Author: 安知鱼
 * @Email: 2268025923@qq.com
 * @Date: 2021-08-28 15:02:57
 * @LastEditTime: 2026-07-07 14:10:00
 * @LastEditors: Mavis
 *
 * BASE_URL 从 .env.{NODE_ENV} 读取：
 *   .env.development  VUE_APP_BASE_URL=/baseinfo
 *   .env.production   VUE_APP_BASE_URL=/baseinfo
 */

const BASE_URL = process.env.VUE_APP_BASE_URL || '/baseinfo'
const TIME_OUT = 10000
const PROJECT_NAME = process.env.VUE_APP_PROJECT_NAME || 'dexin-website'
const PROJECT_ENV =
  process.env.VUE_APP_PROJECT_ENV || process.env.NODE_ENV || 'development'

export { BASE_URL, TIME_OUT, PROJECT_NAME, PROJECT_ENV }
